import { ArticleRelation as ArticleRelationComponent } from './ArticleRelation.component';
import { connector } from './ArticleRelation.connector';
export const ArticleRelation = connector(ArticleRelationComponent);
